<template>
  <Stepper :steps="steps" />
</template>

<script>
import Stepper from "@/components/nav/Stepper";

import ServersTable from "../ServersTableComponent";
import FileSelector from "./PackageFileSelector";
import ServerCard from "../ServerCard";
import Settings from "./PackageUploadSettings";

export default {
  data: () => ({
    steps: [
      {
        title: "Выбор сервера",
        subtitle: "",
        component: ServersTable,
        props: { readOnly: true },
      },
      { title: "Соеденение", subtitle: "", component: ServerCard },
      { title: "Выбор файлов", component: FileSelector },
      { title: "Настройка", subtitle: "Общие параметры", component: Settings },
      { title: "Настройка", subtitle: "Ед.измерения", component: null },
      {
        title: "Отчет",
        subtitle: "Предварительный",
        component: null,
        color: "warning",
      },
      {
        title: "Загрузка",
        subtitle: "Этап 1",
        component: null,
        color: "warning",
      },
      // { title: "Загрузка", subtitle: "Этап 2", component: null },
      {
        title: "Отчет",
        subtitle: "Итоги загрузки",
        component: null,
        color: "blue",
      },
    ],
  }),
  components: {
    Stepper,
  },
};
</script>